import React from 'react'
import { useSelector } from 'react-redux'
import { selectShouldHideNoteEditCallout } from 'ducks/flags/selectors'
import { selectCurrentTicketChangesetsLoaded } from 'selectors/currentChangesets'
import NoteEditCallout from './NoteEditCallout'

const WithNoteEditCallout = ({
  children,
  isTriggerContainerAnimationEnded,
}) => {
  const changesetsLoaded = useSelector(selectCurrentTicketChangesetsLoaded)
  const shouldHide = useSelector(selectShouldHideNoteEditCallout)

  // If container has slide up animation, the tooltip position isn't correct,
  // so shoun't show tooltip
  if (
    !isTriggerContainerAnimationEnded ||
    !changesetsLoaded ||
    shouldHide !== false
  )
    return children
  return <NoteEditCallout>{children}</NoteEditCallout>
}

export default WithNoteEditCallout
